import { ButtonIconPosition } from "CommonControls/ButtonIconPosition";
import { ButtonStyle } from "CommonControls/ButtonStyle";
import { dicontainer } from "DIContainer";
import { HorizontalAlignment } from "CommonControls/HorizontalAlignment";
import Button from "CommonControls/Button";
import ContactElements from "MainLayout/ContactElements";
import ContactFormModel from "Models/ContactFormModel";
import ContactService from "Services/ContactService";
import EventItem from "Pages/Home/EventItem";
import IEmptyProps from "EmptyProps";
import ItemStrip from "CommonControls/ItemStrip";
import React from 'react';
import ServiceItem from "Pages/Home/ServiceItem";
import PageNavigationController from "PageNavigation/PageNavigationController";
import ServiceSpecialtyItem from "Pages/Home/ServiceSpecialtyItem";
import { DOMUtils, HTMLElementProperty, MathUtils, ParallaxAnimation } from 'ts-common-utils';
import ServiceRequestError from 'Services/ServiceRequestError';

interface IHomeState {
    contactFormModel: ContactFormModel;
    showContactFormSendSuccess: boolean;
    showContactFormSendFailure: boolean;
    contactFormSending: boolean;
    contactFormErrorDetails?: ServiceRequestError;
}

export default class Home extends React.Component<IEmptyProps, IHomeState> {
    private _contactService: ContactService = dicontainer.get(ContactService);
    private _parallaxAnimations: ParallaxAnimation[] = [];
    private _pageNavigationController: PageNavigationController = dicontainer.get(PageNavigationController);

    public constructor(props: IEmptyProps) {
        super(props);
        this.state = {
            contactFormModel: new ContactFormModel(),
            showContactFormSendSuccess: false,
            showContactFormSendFailure: false,
            contactFormSending: false,
            contactFormErrorDetails: undefined
        }
        this.handleContactFormTextChanged = this.handleContactFormTextChanged.bind(this);
        this.handleContactFormSendButtonClick = this.handleContactFormSendButtonClick.bind(this);
        this.handleContactFormSendSuccess = this.handleContactFormSendSuccess.bind(this);
        this.handleContactFormSendFailure = this.handleContactFormSendFailure.bind(this);
        this.handlePricingButtonClick = this.handlePricingButtonClick.bind(this);
    }

    public componentDidMount() {
        DOMUtils.findAll(".section.about .item .background").forEach(element => {
            this._parallaxAnimations.push(new ParallaxAnimation(
                element as HTMLElement,
                DOMUtils.findFirst(".app-container"), (progress, element) => {
                    element.setNumericValue(HTMLElementProperty.TranslateY, MathUtils.map(progress, -300, 300));
                }));
        });
        this._parallaxAnimations.push(new ParallaxAnimation(
            DOMUtils.findFirst(".section.contact-details .background"),
            DOMUtils.findFirst(".app-container"), (progress, element) => {
                element.setNumericValue(HTMLElementProperty.TranslateY, MathUtils.map(progress, -200, 200));
            }));
        DOMUtils.findAll(".section.services .specialty-item .background").forEach(element => {
            this._parallaxAnimations.push(new ParallaxAnimation(
                element as HTMLElement,
                DOMUtils.findFirst(".app-container"), (progress, element) => {
                    element.setNumericValue(HTMLElementProperty.TranslateY, MathUtils.map(progress, -75, 75));
                }));
        });

    }

    public componentWillUnmount() {
        this._parallaxAnimations.forEach(p => p.dispose());
    }

    private handleContactFormTextChanged(sender: object, value?: string) {
        let model = this.state.contactFormModel!.clone();
        (model as any)[(sender as any).props.name!] = value;
        this.setState({ contactFormModel: model });
    }

    private handleContactFormSendButtonClick() {
        this.setState({ contactFormSending: true, showContactFormSendFailure: false }, () => {
            this._contactService.sendContactForm(this.state.contactFormModel, this.handleContactFormSendSuccess, this.handleContactFormSendFailure);
        });
    }

    private handleContactFormSendSuccess() {
        this.setState({ contactFormSending: false, showContactFormSendSuccess: true });
    }

    private handleContactFormSendFailure(errorDetails: ServiceRequestError) {
        this.setState({ contactFormSending: false, showContactFormSendFailure: true, contactFormErrorDetails: errorDetails });
    }

    private handlePricingButtonClick() {
        this._pageNavigationController.switch("tarifs");
    }

    public render() {
        return ([
            <div key="main" id="accueil" className="section main">
                <div className="overlay scene"></div>
                <div className="overlay logo" id="overlay-logo">
                    <img className="logo" src="img/logo.svg" />
                </div>
                <a className="overlay-promo" href="https://www.facebook.com/LaBarak.ULaval/videos/1396916097860498/" target="_blank">
                    <div className="arrows"></div>
                    <div className="text">Visualiser la vidéo promo</div>
                    <div className="arrows"> </div>
                </a>
            </div>,
            <div key="about" className="section about">
                <div className="header">
                    <div className="title-container">
                        <h2 className="title">
                            La Barak, c'est:
                        </h2>
                    </div>
                </div>
                <div className="content">
                    <div className="item">
                        <div className="background"></div>
                        <div className="header">
                            <h3 className="title">
                                Tout un party
                            </h3>
                            <div className="subtitle">
                                avec des thématiques originales, une expérience musicale et une ambiance exceptionnelle.
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="background"></div>
                        <div className="header">
                            <h3 className="title">
                                60 000 watts de puissance
                            </h3>
                            <div className="subtitle">
                                avec le système de son et d’éclairage le plus puissant de toutes les universités québécoises au service des associations étudiantes.
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="background"></div>
                        <div className="header">
                            <h3 className="title">
                                Une expertise inégalée
                            </h3>
                            <div className="subtitle">
                                sur le campus en gestion événementielle, en sonorisation et en éclairage.
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            <div key="events" className="section events" id="evenements">
                <div className="header">
                    <div className="title-container">
                        <h2 className="title">
                            Événements
                        </h2>
                    </div>
                </div>
                <div className="content">
                    <ItemStrip>
                        <EventItem link="https://www.facebook.com/events/886509607029318/" imageUrl="img/events/thumbnails/tomorrowland.jpg" date="2025/01/23"></EventItem>
                        <EventItem link="https://www.facebook.com/events/1342483220450589/" imageUrl="img/events/thumbnails/ugly-sweater.jpg" date="2024/12/19"></EventItem>
                        <EventItem link="https://www.facebook.com/events/1647929736128216/" imageUrl="img/events/thumbnails/white-lies-2024.jpg" date="2024/11/21"></EventItem>
                        <EventItem link="https://www.facebook.com/events/407076902398329/" imageUrl="img/events/thumbnails/pool-party.jpg" date="2024/09/19"></EventItem>
                        <EventItem link="https://www.facebook.com/events/469464592262776/" imageUrl="img/events/thumbnails/st-jean-2024.jpg" date="2024/06/20"></EventItem>
                        <EventItem link="https://www.facebook.com/events/2710394452459557/" imageUrl="img/events/thumbnails/coco-bongo.jpg" date="2024/05/02"></EventItem>
                        <EventItem link="https://www.facebook.com/events/2621189231390744/" imageUrl="img/events/thumbnails/fire-and-ice.jpg" date="2024/01/25"></EventItem>
                        <EventItem link="https://www.facebook.com/events/713721307388510/" imageUrl="img/events/thumbnails/snowbird.jpg" date="2023/12/21"></EventItem>
                        <EventItem link="https://www.facebook.com/events/327746303195704/" imageUrl="img/events/thumbnails/footloose.jpg" date="2023/11/16"></EventItem>
                        <EventItem link="https://www.facebook.com/events/332403789245643/" imageUrl="img/events/thumbnails/sea-shack-reprise.jpg" date="2023/09/21"></EventItem>
                        <EventItem link="https://www.facebook.com/events/233254925953351/" imageUrl="img/events/thumbnails/red-flags.jpg" date="2023/04/27"></EventItem>
                        <EventItem link="https://www.facebook.com/events/758700752320409/" imageUrl="img/events/thumbnails/irish-2023.jpg" date="2023/03/16"></EventItem>
                        <EventItem link="https://www.facebook.com/events/803442230696229/" imageUrl="img/events/thumbnails/ugly-sweater-party.jpg" date="2022/12/02"></EventItem>
                        <EventItem link="https://www.facebook.com/events/510533220976708/" imageUrl="img/events/thumbnails/white-lies.jpg" date="2022/11/17"></EventItem>
                        <EventItem link="https://www.facebook.com/events/844027716596287/" imageUrl="img/events/thumbnails/halloween-2.jpg" date="2022/10/29"></EventItem>
                        <EventItem link="https://www.facebook.com/events/652832606173489/" imageUrl="img/events/thumbnails/sea-shack.jpg" date="2022/09/22"></EventItem>
                        <EventItem link="https://www.facebook.com/events/1036965727012653/" imageUrl="img/events/thumbnails/welcome-to-the-jungle.jpg" date="2022/09/01"></EventItem>
                        <EventItem link="https://www.facebook.com/events/686630115788184/" imageUrl="img/events/thumbnails/chaud-bateau.jpg" date="2022/04/28"></EventItem>
                        <EventItem link="https://www.facebook.com/events/691439285532234/" imageUrl="img/events/thumbnails/full-moon.jpg" date="2022/04/02"></EventItem>
                        <EventItem link="https://www.facebook.com/events/912344516096435/" imageUrl="img/events/thumbnails/irish-2.jpg" date="2022/03/17"></EventItem>
                        <EventItem link="https://www.facebook.com/events/196936042607105/" imageUrl="img/events/thumbnails/noel-du-campeur.jpg" date="Annulée"></EventItem>
                        <EventItem link="https://www.facebook.com/events/921579705432945/" imageUrl="img/events/thumbnails/bal-masque.jpg" date="2021/11/04"></EventItem>
                        <EventItem link="https://www.facebook.com/events/553268882064109/" imageUrl="img/events/thumbnails/irish.jpg" date="Annulée"></EventItem>
                        <EventItem link="https://www.facebook.com/events/245350436452833/" imageUrl="img/events/thumbnails/en-blanc.jpg" date="2020/02/13"></EventItem>
                        <EventItem link="https://www.facebook.com/events/2492824897630631/" imageUrl="img/events/thumbnails/ice-party.jpg" date="2020/01/23"></EventItem>
                        <EventItem link="https://www.facebook.com/events/1393008300881699/" imageUrl="img/events/thumbnails/pajama-party.jpg" date="2019/12/05"></EventItem>
                        <EventItem link="https://www.facebook.com/events/2750619351637859/" imageUrl="img/events/thumbnails/halloween.jpg" date="2019/10/03"></EventItem>
                        <EventItem link="https://www.facebook.com/events/388734912048498/" imageUrl="img/events/thumbnails/throwback-2000.jpg" date="2019/10/03"></EventItem>
                        <EventItem link="https://www.facebook.com/events/450653705528733/" imageUrl="img/events/thumbnails/alaclair-ensemble.jpg" date="2019/09/05"></EventItem>
                        <EventItem link="https://www.facebook.com/events/450653705528733/" imageUrl="img/events/thumbnails/too-cool-for-school.jpg" date="2019/09/05"></EventItem>
                    </ItemStrip>
                    <div className="coming-up">À venir: ---</div>
                </div>
            </div>,
            <div key="services" className="section services" id="services">
                <div className="header">
                    <div className="title-container">
                        <h2 className="title">
                            Services
                        </h2>
                    </div>
                </div>
                <div className="content">
                    <div className="specialties-grid">
                        <div className="specialty-row">
                            <ServiceSpecialtyItem title="Partys" photoUrl="img/backgrounds/party-people-cheering.jpg" reversed={false}></ServiceSpecialtyItem>
                            <ServiceSpecialtyItem title="Bals de finissants" photoUrl="img/backgrounds/prom-night-after-grad-party.jpg" reversed={false}></ServiceSpecialtyItem>
                        </div>
                        <div className="specialty-row">
                            <ServiceSpecialtyItem title="Soupers" photoUrl="img/backgrounds/wedding-reception-supper-table.jpg" reversed={true}></ServiceSpecialtyItem>
                            <ServiceSpecialtyItem title="Intégrations" photoUrl="img/backgrounds/university-student-initiations.jpg" reversed={true}></ServiceSpecialtyItem>
                        </div>
                        <div className="specialty-row">
                            <ServiceSpecialtyItem title="Vins et fromages" photoUrl="img/backgrounds/wine-and-cheese-supper.jpg" reversed={false}></ServiceSpecialtyItem>
                            <ServiceSpecialtyItem title="Défilés de mode" photoUrl="img/backgrounds/fashion-show-runway.jpg" reversed={false}></ServiceSpecialtyItem>
                        </div>
                    </div>
                    <div className="service-grid-container">
                        <div className="service-grid" id="service-grid">
                            <div className="service-item-group">
                                <ServiceItem iconUrl="img/icons/rental-1472BA.svg" title="Location"></ServiceItem>
                                <ServiceItem iconUrl="img/icons/speaker-1472BA.svg" title="Sonorisation"></ServiceItem>
                            </div>
                            <div className="service-item-group">
                                <ServiceItem iconUrl="img/icons/spotlight-1472BA.svg" title="Éclairage"></ServiceItem>
                                <ServiceItem iconUrl="img/icons/cable-1472BA.svg" title="Câblage"></ServiceItem>
                            </div>
                            <div className="service-item-group">
                                <ServiceItem iconUrl="img/icons/wrench-hand-1472BA.svg" title="Installation"></ServiceItem>
                                <ServiceItem iconUrl="img/icons/record-player-1472BA.svg" title="DJ"></ServiceItem>
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            <div key="tarifs" className="section tarifs" id="tarifs">
                <div className="header">
                    <div className="title-container">
                        <h2 className="title">
                            Tarifs
                        </h2>
                    </div>
                </div>
                <div className="content">
                    <div className="buttons">
                        <Button style={ButtonStyle.StandardPrimary} text={"Prix des équipements"} normalIconImage={"img/icons/us-dollar-filled-FFFFFF.svg"} iconPosition={ButtonIconPosition.Left}
                            wide={true} onClick={this.handlePricingButtonClick} />
                    </div>
                </div>
            </div>,
            <div key="contact-us" id="nous-joindre" className="section contact-us">
                <div className="section contact-details">
                    <div className="background"></div>
                    <div className="background-cover"></div>
                    <div className="header">
                        <div className="title-container">
                            <h2 className="title">
                                Nous joindre
                            </h2>
                        </div>
                    </div>
                    <div className="content">
                        <ContactElements lightTheme={true} horizonalAlign={HorizontalAlignment.Center} address={"2305 Rue de l'Université (Pavillon Maurice-Pollack), local 2265, Québec, QC G1V 0A6"}
                            email={"labarak@asso.ulaval.ca"} facebookPageName={"labarak.ulaval"} instagramPageName={"labarak.ul"} />
                    </div>
                </div>
                <div className="map">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d442.9174979113021!2d-71.26978750356606!3d46.77891652715239!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cb896c7a020a8e7%3A0xf99bb86a48d7c984!2sConf%C3%A9d%C3%A9ration%20des%20Associations%20d&#39;%C3%A9tudiants%20et%20%C3%A9tudiantes%20de%20l&#39;Universit%C3%A9%20Laval!5e0!3m2!1sen!2sca!4v1717200003574!5m2!1sen!2sca"
                        frameBorder={0} style={{ border: 0 }} allowFullScreen={false}></iframe>
                </div>
            </div>
        ]
        );
    }
}